import React from "react";
import { Table } from "antd";

export default function QuotationAndDepositTab() {
    // 1. Dữ liệu Lịch sử báo giá
    const quotationData = [
        {
            key: "1",
            date: "12/10",
            code: "BG-1012-01",
            service: "Phác đồ K·Lift",
            price: "Giá từ 8.000.000 đ",
            person: "NV-02",
            status: "Khách phản hồi · đợi vé máy bay · hạn 31/10",
        },
        {
            key: "2",
            date: "10/12/2025",
            code: "BG-1210-04",
            service: "Phác đồ K·Reskin · buổi trải nghiệm",
            price: "Giá từ 6.000.000 đ",
            person: "NV-02",
            status: "Đã chuyển cơ sở",
        },
    ];

    const quotationColumns = [
        { title: "Ngày", dataIndex: "date", key: "date", width: "12%" },
        { title: "Mã", dataIndex: "code", key: "code", width: "15%", render: (text: string) => <span className="font-semibold text-gray-900 dark:text-gray-100">{text}</span> },
        { title: "Gói / dịch vụ", dataIndex: "service", key: "service", width: "30%", render: (text: string) => <span className="font-medium text-gray-800 dark:text-gray-200">{text}</span> },
        { title: "Giá", dataIndex: "price", key: "price", width: "18%" },
        { title: "Người báo", dataIndex: "person", key: "person", width: "10%" },
        { title: "Trạng thái", dataIndex: "status", key: "status", width: "15%" },
    ];

    // 2. Dữ liệu Cọc
    const depositData = [
        {
            key: "1",
            depositCode: "CO-1012-01",
            date: "12/10",
            amount: "2.000.000 đ",
            purpose: "Giữ lịch 18/12",
            status: "Chờ chuyển khoản",
        },
    ];

    const depositColumns = [
        { title: "Mã cọc", dataIndex: "depositCode", key: "depositCode", width: "20%", render: (text: string) => <span className="font-semibold text-gray-900 dark:text-gray-100">{text}</span> },
        { title: "Ngày", dataIndex: "date", key: "date", width: "15%" },
        { title: "Số tiền", dataIndex: "amount", key: "amount", width: "22%", render: (text: string) => <span className="font-bold text-gray-900 dark:text-gray-100">{text}</span> },
        { title: "Mục đích", dataIndex: "purpose", key: "purpose", width: "23%" },
        { title: "Trạng thái", dataIndex: "status", key: "status", width: "20%", render: (text: string) => <span className="text-amber-700 font-bold dark:text-amber-400">{text}</span> },
    ];

    return (
        <div className="space-y-4 pt-1 text-xs animate-fade-in text-gray-800 dark:text-gray-200">
            
            {/* Khối 1: Lịch sử báo giá */}
            <div className="space-y-1.5">
                <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Lịch sử báo giá</div>
                <div className="border border-[#3E91AB]/30 rounded overflow-hidden">
                    <Table
                        dataSource={quotationData}
                        columns={quotationColumns}
                        pagination={false}
                        size="small"
                        className="custom-quote-table"
                        scroll={{ x: "max-content" }}
                    />
                </div>
            </div>

            {/* Khối 2: Cọc */}
            <div className="space-y-1.5 pt-1">
                <div className="flex items-center gap-2">
                    <span className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Cọc</span>
                    <span className="bg-[#d97706] text-white text-[10px] px-1.5 py-0.2 rounded font-bold cursor-pointer">[?] chính sách cọc</span>
                </div>
                <div className="border border-[#3E91AB]/30 rounded overflow-hidden">
                    <Table
                        dataSource={depositData}
                        columns={depositColumns}
                        pagination={false}
                        size="small"
                        className="custom-quote-table"
                        scroll={{ x: "max-content" }}
                    />
                </div>
            </div>

            {/* Chú thích cuối tab */}
            <div className="pt-2 text-[11px] text-gray-500 leading-relaxed border-t border-gray-100 dark:border-gray-800">
                App CSKH: chỉ đọc, ẩn mức trợ giá. Khách cũ mua thêm qua CSKH (R23) dùng cùng luồng báo giá với ngưỡng quyền riêng <span className="bg-[#d97706] text-white text-[10px] px-1.5 py-0.2 rounded font-bold cursor-pointer">[?]</span>
            </div>
        </div>
    );
}